import { createStore } from 'jotai/vanilla';

export const atomStore = createStore();
